import React from 'react'
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap'
import { indexOf } from 'lodash'

const TabbedContent = ({ children, tabs, theme }) => {
  return (
    <Container
      fluid
      className={`px-0 tabbed-content mt-5 pt-3 ${theme ? theme : ''}`}
    >
      <Container>
        <Row>
          <Col className='px-0 px-md-3'>
            <Tabs defaultActiveKey={tabs.titles[0]}>
              {tabs.titles.map((title, index) => {
                return (
                  <Tab
                    eventKey={title}
                    title={title}
                    key={index}
                    className='px-3 px-md-0'
                  >
                    {children[indexOf(tabs.titles, title)]}
                  </Tab>
                )
              })}
            </Tabs>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default TabbedContent
